// Footer.tsx
import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear(); // aktuelles Jahr automatisch

  return (
    <footer
      style={{
        backgroundColor: '#f8f8f8',
        padding: '20px',
        textAlign: 'center',
        fontSize: '14px',
        color: '#333',
      }}
    >
      <p>&copy; {currentYear} MBSoftwareSolutions. Alle Rechte vorbehalten.</p>
      
      <nav style={{ marginTop: '10px' }}>
        <a
          href="https://mbsoftwaresolutions.de/produkte/rescueplattform/rescueofficer/agb"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#0073e6', textDecoration: 'none', margin: '0 15px' }}
        >
          AGB
        </a>
        <a
          href="https://mbsoftwaresolutions.de/produkte/rescueplattform/rescueofficer/datenschutzerklaerung"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#0073e6', textDecoration: 'none', margin: '0 15px' }}
        >
          Datenschutz
        </a>
        <a
          href="https://mbsoftwaresolutions.de/produkte/rescueplattform/rescueofficer/nutzungsbedingungen"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#0073e6', textDecoration: 'none', margin: '0 15px' }}
        >
          Nutzungsbedingungen
        </a>
      </nav>
    </footer>
  );
};

export default Footer;